import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-217eaf5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "check-box-holder" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "description-step" }
const _hoisted_4 = { class: "upper-row" }
const _hoisted_5 = { class: "lower-row" }
const _hoisted_6 = { class: "tags" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "singleresource"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sorry, no resources yet available here", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["step-body", _ctx.stepCompletedClass])
  }, [
    _createElementVNode("div", {
      class: "header",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandDetailedView($event)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          class: "check",
          type: "checkbox",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.check($event))),
          checked: _ctx.step.completed
        }, null, 40, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: _normalizeClass(["step-name", _ctx.stepCompletedTitleClass])
          }, _toDisplayString(_ctx.step.topic.name), 3)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(["level", _ctx.levelColorClasses[_ctx.step.topic.level]])
          }, _toDisplayString(_ctx.step.topic.level), 3),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.step.topic.tags, (tag) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "tag",
                key: tag
              }, _toDisplayString(tag), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.detailedExpandedClass, "detailed"])
    }, [
      _hoisted_7,
      (_ctx.resourcesNotEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.step.topic.resources, (res) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "singleresource",
          key: res.link
        }, [
          _createElementVNode("img", {
            src: _ctx.imgs[res.type],
            alt: ""
          }, null, 8, _hoisted_11),
          _createElementVNode("a", {
            target: "_blank",
            href: res.link
          }, _toDisplayString(res.name), 9, _hoisted_12)
        ]))
      }), 128))
    ], 2)
  ], 2))
}